import { FuseNavigation } from 'admin/@fuse/types';
import { DevSectionPermission } from 'admin/appModel/Company';
import { AppConstants } from 'admin/utile/AppConstants';

export const navigationDev: FuseNavigation[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        url: '/dashboard'
    },
    {
        id: 'templates',
        title: 'Templates',
        type: 'item',
        url: '/templates'
    },
    {
        id: 'account-group',
        title: 'Account',
        type: 'group',
        isAccount: true,
        children: [
            {
                id: 'accout',
                title: 'Accout Settings',
                type: 'item',
                isAccount: true,
                url: '/settings'
            },
            {
                id: 'devtools',
                title: 'Dev Tools',
                type: 'item',
                isDevTools: true,
                permissionName: DevSectionPermission.DeveloperTools,
                url: '/devtools'
            },
            {
                id: 'logout',
                title: 'Logout',
                type: 'item',
                isAccount: true,
                redirectTo: AppConstants.baseUrl + '/account/dev',
                function: () => { }
            }
        ]
	},
	{
		id: 'contact-us',
		title: 'Contact Us',
		type: 'item',
		isAccount: true,
		function: () => { }
	}
];
